import { render, staticRenderFns } from "./parcel_gift.vue?vue&type=template&id=fd92b79e&"
import script from "./parcel_gift.vue?vue&type=script&lang=js&"
export * from "./parcel_gift.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports